var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout--full-page"},[_c('router-view'),(!_vm.isProduction)?_c('div',{staticClass:"corner-ribbon top-left sticky red"},[_vm._v(_vm._s(_vm.bannerValue))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }